import { checkPermissions } from '../../../../lib/helper'

const handleCheckRole = async (
  permissions,
  matchingName,
  user_type,
  is_gps_vendor,
) => {
  let can_special_1 = checkPermissions(
    permissions,
    matchingName,
    'can_special_1',
  ) // clerk
  let can_special_2 = checkPermissions(
    permissions,
    matchingName,
    'can_special_2',
  ) // admin
  let can_special_3 = checkPermissions(
    permissions,
    matchingName,
    'can_special_3',
  ) // cpac
  let can_special_4 = checkPermissions(
    permissions,
    matchingName,
    'can_special_4',
  ) // mixer_truck_center

  // TODO:เช็ค role
  let role = 'contractor' // default เป็น contractor ไปเลย พี่ปูแจ้งไว้
  if (can_special_1) {
    role = 'clerk'
  } else if (can_special_2) {
    role = 'admin'
  } else if (can_special_3) {
    role = 'cpac'
  } else if (can_special_4) {
    role = 'mixer_truck_center'
  } else if (is_gps_vendor) {
    role = 'gps_vendor'
  }

  return role
}

export { handleCheckRole }
